import React, { useCallback } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import {
  currentFiltersSelector,
  SBAT_GROUP_FILTERS,
  setFilterValue,
} from 'features/classCreation';
import { FILTER_TYPE } from 'data/filterType';
import DateInput from 'components/DateInput';
import Field from 'components/Field';
import styles from './DateRangeFilter.module.scss';

function DateRangeFilter() {
  const dispatch = useDispatch();
  const { fromDate, toDate } = useSelector(currentFiltersSelector);

  const handleFromDateChange = useCallback(
    (date) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.fromDate,
          value: date,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  const handleToDateChange = useCallback(
    (date) => {
      dispatch(
        setFilterValue({
          key: SBAT_GROUP_FILTERS.toDate,
          value: date,
          type: FILTER_TYPE.current,
        })
      );
    },
    [dispatch]
  );

  return (
    <Field
      label="Date Range"
      labelClassName="h5"
    >
      <div className="row">
        <DateInput
          className={classNames(styles.dateInput, 'm-r-xs')}
          value={fromDate}
          onChange={handleFromDateChange}
          placement="top"
          placeholder="From"
        />
        <DateInput
          className={styles.dateInput}
          value={toDate}
          onChange={handleToDateChange}
          placement="top"
          placeholder="To"
        />
      </div>
    </Field>
  );
}

export default DateRangeFilter;
